var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-footer-indicators"},[_c('div',{staticClass:"section-footer-indicators__dots"},_vm._l((_vm.dotsCount),function(dot){return _c('span',{key:dot,staticClass:"section-footer-indicators__dot",class:{'section-footer-indicators__dot--inactive': dot !== _vm.currentDot}})}),0),_c('IndicatorsMouse')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }